<template>
  <div>
      <div>
        {{ data.veranstaltungsTyp }}
      </div>
      <div>
        <strong>
          {{ data.name }}
        </strong>
      </div>
      <div>
        {{ data.organisationseinheit.name }}<span v-if="hasAdditionalOUs">; {{additionalOUs}}</span>
      </div>
      <div v-if="data.veranstalter != null && data.veranstalter.length != 0">
        <em>
          <translate>Veranstaltung.form.veranstalter</translate>
        </em> :
        {{ veranstalter }}
      </div>
      <div>
        {{ dateRange }}
      </div>
  </div>
</template>

<script>
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import CompactViewHelper from '@/components/mixins/CompactViewHelper'

export default {
  name: 'fob-veranstaltung-compact',
  props: ['schema', 'data'],
  mixins: [DateTimeHelper, CompactViewHelper],
  computed: {
    veranstalter () {
      return this.data.veranstalter.map(this.fullName).join('; ')
    },
    dateRange () {
      let range = []
      let start
      let end
      if (this.data.veranstaltungStart != null) {
        start = this.asDate(this.data.veranstaltungStart)
        range.push(start)
      }
      if (this.data.veranstaltungEnde != null) {
        end = this.asDate(this.data.veranstaltungEnde)
        if (start !== end) {
          range.push(end)
        }
      }
      return range.join(' - ')
    },
    hasAdditionalOUs () {
      return this.data.weitereOrganisationseinheiten != null && this.data.weitereOrganisationseinheiten.length > 0
    },
    additionalOUs () {
      return this.data.weitereOrganisationseinheiten.map(x => x.name).join('; ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/compact/Veranstaltung.vue